<template>
    <footer class="footer-area bg-dark"  dir="rtl">
        <div class="container content-footer" >
            <div class="border-bottom" style="border-color: whitesmoke;">
                <div class="row ">
                    <div class=" footer-bloc col-12 col-lg-4 d-flex justify-content-center align-items-start mt-lg-4">
                        <div  style="width: 130px; margin-bottom: auto;margin-top: auto;">
                            <img class="logo" src="../assets/republic-stamp.svg" alt="" >
                        </div>
                    </div>
                    <div class="middle-bloc col-12 col-lg-4  section-contact mt-sm-2 d-flex justify-content-center">
                        <div>
                            <h6 class="text-light ml-50" >{{ $t('contact') }}</h6>
                            <ul class=" section-body mb-30">
                                <li class=" mt-2 text-light">  <font-awesome-icon icon="fa-solid fa-phone" /> &nbsp;&nbsp;<span class="section-contact-info"> الهاتف : 07 51 69 21 (0) 213+</span></li>
                                <li class=" mt-2 text-light"> <font-awesome-icon icon="fa-solid fa-fax" /> &nbsp;&nbsp;<span class="section-contact-info"> الفاكس : 25 54 69 21 (0) 213+</span></li>
                                <li class=" mt-2 contact-email text-light"><a href="mailto:" target="_blank" style="text-decoration: none; color: white"><font-awesome-icon icon="fa-solid fa-envelope" />  &nbsp;&nbsp;<span class="section-contact-info">&nbsp;contact@nssa.dz</span></a> </li>
                            </ul>
                        </div>
                    </div>
                    <div class=" footer-bloc col-12 col-lg-4 d-flex justify-content-center align-items-start mt-lg-4">
                        <div  style="width: 130px; margin-bottom: auto;margin-top: auto;">
                            <img class="logo" src="../assets/logo_footer.png" width="160" alt="" >
                        </div>
                    </div>
                </div>
            </div>
            <h6 class="text-center pt-1 droit-reseve" style="color: lightgray;"> 2022 ® كل الحقوق محفوظة . الوكالة الوطنية للأمن الصحي  </h6>
        </div>
    </footer>

</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style>
    .section-body{
        border-right: 4px solid #454d54;
        margin: 30px 0;
    }
    footer{
        padding-top: 20px;
        font-family: DroidArabic;
        font-size:var(--m-font-size);
        padding-bottom: 20px;
        margin-top: auto;
    }

    .footer-bloc, .middle-bloc{
        padding-top: 40px;
        padding-bottom: 40px;
    }
    @media (max-width: 991px){
        .middle-bloc{
            padding-top: 0;
            padding-bottom: 0;
        }
    }

    footer .droit-reseve{
        font-size: var(--s-font-size);
    }

    footer ul{
        padding-left: 0;
    }

</style>

